export enum ExternalUserEventType {
  Trigger = 1,
  CarePortal = 2,
  Enrollment = 3,
  CareCompassIdUpdate = 4
}
